import React from 'react'
import ReactDOM from 'react-dom'
import AppDemo from 'app/AppDemo.jsx'

import 'app/assets/scss/index.scss'

const pkgPath = '/home/lapis/repos/gh/formiga'

const pkgJson = JSON.parse(`
  {
  "name": "formiga",
  "version": "0.1.8",
  "description": "The simplest -yet effective- form validator for React",
  "keywords": [
    "js",
    "react",
    "form",
    "validation"
  ],
  "author": "Donato Lorenzo <donato@afialapis.com>",
  "contributors": [
    "Donato Lorenzo <donato@afialapis.com>"
  ],
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/afialapis/formiga.git"
  },
  "bugs": {
    "url": "https://github.com/afialapis/formiga/issues"
  },
  "homepage": "https://formiga.afialapis.com/",
  "files": [
    "lib",
    "dist",
    "logo",
    "docaine.json",
    "formiga.png"
  ],
  "type": "module",
  "main": "./lib/index.cjs",
  "cjs": "./dist/formiga.cjs",
  "browser": "./dist/formiga.umd.js",
  "module": "./dist/formiga.mjs",
  "exports": {
    "import": "./dist/formiga.mjs",
    "default": "./lib/index.cjs",
    "require": "./dist/formiga.cjs"
  },
  "scripts": {
    "clean-demo": "rm -rf demo/dist",
    "clean-lib": "rm -rf lib && mkdir lib",
    "clean-dist": "rm -rf dist && mkdir dist",
    "clean-site": "rm -rf arredemo",
    "clean-all": "npm run --silent clean-demo && npm run --silent clean-lib && npm run --silent clean-dist && npm run --silent clean-site",
    "lint": "npx xeira lint",
    "test": "npx xeira test --files=./test/before.mjs,./test/units/*.cjs",
    "lib": "npm run --silent clean-lib && npx xeira transpile",
    "dist": "npm run --silent clean-dist && npx xeira bundle",
    "site": "npm run --silent clean-site && npx xeira site",
    "prepare": "npm run --silent clean-demo && npm run --silent lint && npm run --silent test && npm run --silent lib && npm run --silent dist && npm run --silent site",
    "demo": "npm run --silent clean-demo && npx xeira demo --port=8001",
    "reset": "npm run --silent clean-all && rm -fr node_modules package-lock.json && npm i"
  },
  "devDependencies": {
    "xeira": "^0.3.3"
  },
  "peerDependencies": {
    "react": ">=16.13.1"
  },
  "eslintConfig": {
    "extends": [
      "./node_modules/xeira/configs/eslint.react.cjs"
    ]
  }
}
`)

const arreConfig = JSON.parse(`
{
  "theme": "default",
  "company": "Afialapis",
  "url": "formiga.afialapis.com",
  "doc_versions": [],
  "md": {
    "md_keep_summary_content": false,
    "md_strip_details_tag": true
  },
  "demo_entry": "demo/src/Demo.js",
  "has_demo": true,
  "logo": {
    "ok": true,
    "src": "logo/formiga_200.png",
    "dest": "logo.png"
  },
  "favicon": {
    "main": {
      "ok": true,
      "src": "logo/favicon/formiga.png",
      "dest": "favicon.png"
    },
    "ico": {
      "ok": true,
      "src": "logo/favicon/formiga.ico",
      "dest": "favicon.ico"
    },
    "apple": {
      "ok": true,
      "src": "logo/favicon/formiga_apple.png",
      "dest": "favicon_apple.png"
    }
  }
}
`)


ReactDOM.render(
  <AppDemo 
    pkgPath = {pkgPath}
    pkgJson = {pkgJson}
    arreConfig = {arreConfig}
    
  />, 
  document.getElementById('arredemo-app'))

/*

// React 18

ReactDOM.createRoot(document.getElementById("arredemo-app")).render(
  <React.StrictMode>
    <AppDemo 
      pkgPath = {pkgPath}
      pkgJson = {pkgJson}
      arreConfig = {arreConfig}
      
    />
  </React.StrictMode>
);
*/
